var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-100"},[_c('EventForm',{attrs:{"wizard-ref":_vm.wizard_ref},on:{"submitted":function($event){return _vm.$emit('submitted', true)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }